import { GridLegacy as Grid } from '@mui/material';
import { Box } from '@mui/system';
import { SwipableDialog } from '@tix-ticketing/ui-components';
import { useIntl } from 'react-intl';
import type { EventDto } from 'api/generated/types.gen';
import { CalendarEventButton, CalendarEventButtonStatusLabel } from 'components/common/buttons/calendar-event-button';
export const EventsListDialog = ({
  open,
  onClose,
  eventGroupId,
  events
}: {
  open: boolean;
  onClose: () => void;
  eventGroupId: number;
  events: EventDto[];
}) => {
  const intl = useIntl();
  return <SwipableDialog open={open} onClose={onClose} maxWidth="sm" headerText={intl.formatMessage({
    id: "event.availableTimes.title",
    defaultMessage: [{
      "type": 0,
      "value": "Available times"
    }]
  })} subtitleText={intl.formatMessage({
    id: "event.availableTimes.description",
    defaultMessage: [{
      "type": 0,
      "value": "Choose from available times"
    }]
  })}>
      <form>
        <Grid container spacing={1} columns={2} sx={{
        my: 2
      }}>
          {events?.map(event => <Grid item xs={2} sm={1} key={event.id}>
              <CalendarEventButton event={event} href={`/${eventGroupId}/event/${event.id}`} size="medium" fullWidth />
            </Grid>)}
        </Grid>
        <Box sx={{
        pt: 3
      }}>
          <CalendarEventButtonStatusLabel />
        </Box>
      </form>
    </SwipableDialog>;
};